import React, { useState } from 'react';
import api from '../services/api';
import '../styles/recuperacion.css';

function RecuperacionPassword({ onVolver }) {
  const [paso, setPaso] = useState(1); // 1: solicitar, 2: ingresar token, 3: resetear
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [mensaje, setMensaje] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Paso 1: Solicitar reseteo
  const solicitarReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensaje('');
    setError('');

    try {
      const response = await api.post('/password-reset-request', { email });
      setMensaje(response.data.message);
      
      // Token devuelto solo en desarrollo
      if (response.data.token) {
        setToken(response.data.token);
      }
      
      // Avanzar al siguiente paso
      setTimeout(() => setPaso(2), 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Error en la solicitud');
    } finally {
      setLoading(false);
    }
  };

  // Paso 2: Validar token
  const validarToken = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensaje('');
    setError('');

    try {
      const response = await api.get(`/password-reset/${token}`);
      setMensaje(response.data.message);
      
      // Avanzar al siguiente paso
      setTimeout(() => setPaso(3), 1500);
    } catch (err) {
      setError(err.response?.data?.error || 'Token inválido');
    } finally {
      setLoading(false);
    }
  };

  // Paso 3: Resetear contraseña
  const resetearPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensaje('');
    setError('');

    if (password !== passwordConfirm) {
      setError('Las contraseñas no coinciden');
      setLoading(false);
      return;
    }

    if (password.length < 6) {
      setError('La contraseña debe tener mínimo 6 caracteres');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post(`/password-reset/${token}`, {
        password,
        passwordConfirm
      });
      setMensaje('✅ ' + response.data.message);
      
      // Limpiar y volver al inicio después de 2 segundos
      setTimeout(() => {
        setPaso(1);
        setEmail('');
        setToken('');
        setPassword('');
        setPasswordConfirm('');
      }, 2000);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al resetear contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="recuperacion-container">
      <div className="recuperacion-box">
        <h1>🔐 Recuperar Contraseña</h1>

        {/* Mensajes */}
        {mensaje && <div className="mensaje-exito">{mensaje}</div>}
        {error && <div className="mensaje-error">{error}</div>}

        {/* Paso 1: Solicitar Reset */}
        {paso === 1 && (
          <form onSubmit={solicitarReset} className="formulario-paso">
            <h2>Paso 1: Ingresa tu Email</h2>
            <p className="descripcion">
              Recibirás un email con un enlace para resetear tu contraseña.
            </p>
            
            <div className="form-grupo">
              <label>Email:</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="tu@email.com"
                className="form-input"
              />
            </div>

            <button type="submit" disabled={loading} className="btn-enviar">
              {loading ? 'Enviando...' : 'Enviar Instrucciones'}
            </button>
          </form>
        )}

        {/* Paso 2: Validar Token */}
        {paso === 2 && (
          <form onSubmit={validarToken} className="formulario-paso">
            <h2>Paso 2: Ingresa el Token</h2>
            <p className="descripcion">
              Revisa tu email y copia el código de recuperación.
            </p>

            <div className="form-grupo">
              <label>Token:</label>
              <input
                type="text"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                required
                placeholder="Código de 64 caracteres"
                className="form-input"
              />
            </div>

            <button type="submit" disabled={loading} className="btn-enviar">
              {loading ? 'Validando...' : 'Validar Token'}
            </button>

            <button
              type="button"
              onClick={() => setPaso(1)}
              className="btn-volver"
            >
              ← Volver
            </button>
          </form>
        )}

        {/* Paso 3: Resetear Contraseña */}
        {paso === 3 && (
          <form onSubmit={resetearPassword} className="formulario-paso">
            <h2>Paso 3: Nueva Contraseña</h2>
            <p className="descripcion">
              Ingresa una nueva contraseña para tu cuenta.
            </p>

            <div className="form-grupo">
              <label>Nueva Contraseña:</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Mínimo 6 caracteres"
                className="form-input"
              />
            </div>

            <div className="form-grupo">
              <label>Confirmar Contraseña:</label>
              <input
                type="password"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                required
                placeholder="Repite la contraseña"
                className="form-input"
              />
            </div>

            <button type="submit" disabled={loading} className="btn-enviar">
              {loading ? 'Actualizando...' : 'Actualizar Contraseña'}
            </button>

            <button
              type="button"
              onClick={() => setPaso(2)}
              className="btn-volver"
            >
              ← Volver
            </button>
          </form>
        )}

        {/* Link al Login */}
        <div className="link-login">
          <p>
            ¿Recuerdas tu contraseña?{' '}
            <button 
              type="button"
              onClick={onVolver}
              style={{ background: 'none', border: 'none', color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
            >
              Inicia sesión aquí
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}

export default RecuperacionPassword;
